import { EventTypeEnum } from '@builddocs/data-management'

import { BDNotificationAct } from './actEvent'
import { ExonNotificationAct } from './actEvent'
import { NotificationListItemProps } from './NotificationItem'

export const NotificationBody = (props: NotificationListItemProps) => {
  const { notification, onClosePopover, refetch, ...rest } = props

  switch (notification.eventType) {
    case EventTypeEnum.ACT:
      return (
        <BDNotificationAct
          notification={notification}
          refetch={refetch}
          onClosePopover={onClosePopover}
          {...rest}
        />
      )
    case EventTypeEnum.EXON:
      return (
        <ExonNotificationAct
          notification={notification}
          refetch={refetch}
          onClosePopover={onClosePopover}
          {...rest}
        />
      )
    default:
      return null
  }
}
